import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig.js";
import { callMsGraph } from "./graph.js";
import msalInstance, { handleRedirectPromiseLogin } from "./MsalInstance.js";

const instance = msalInstance;

async function RequestProfileData() {
    const accountsAct = instance.getActiveAccount();
    let datosrestorno = await instance
        .acquireTokenSilent({
            ...loginRequest,
            account: accountsAct,
        })
        .then((response) => {
            let res = callMsGraph(response.accessToken).then((response) => {
                // console.log(response)
                return response
            });
            return res
        });
    return datosrestorno
}

async function redirectEntraID() {
    instance.loginRedirect(loginRequest).catch(e => {
    });
}

export async function awaitSession() {
    await handleRedirectPromiseLogin();
    //console.log("Init Session")
    const accountsAct = instance.getActiveAccount();
    //console.log("Account review.")
    if (!accountsAct) {
        //console.log("No account. Redirect...")
        await redirectEntraID()
    }
    else {
        //console.log("Account Found", accountsAct)
        return accountsAct
    }
}